@use '@/styles/tokens' as *;

// Figma Tabs (node 138-1925): primary = pill segmented, secondary = underline.

.pill {
  :global(.ant-tabs-nav)::before {
    display: none;
  }

  :global(.ant-tabs-ink-bar) {
    display: none;
  }

  :global(.ant-tabs-nav-list) {
    gap: 2px;
    padding: var(--space-1) var(--space-2);
    background: $color-light-brown-100;
    border-radius: 24px;
  }

  :global(.ant-tabs-tab) {
    margin: 0;
    padding: 6px 12px;
    border-radius: 20px;
  }

  :global(.ant-tabs-tab-active) {
    background: var(--surface-card);
    border-radius: 24px;
    box-shadow: var(--shadow-tab);
  }
}

.underline {
  :global(.ant-tabs-nav)::before {
    border-bottom-color: var(--border-subtle);
  }

  :global(.ant-tabs-tab) {
    padding: var(--space-1) var(--space-3) 6px;
  }

  :global(.ant-tabs-ink-bar) {
    height: 2px;
  }
}

.fill {
  :global(.ant-tabs-nav-list) {
    width: 100%;
  }

  :global(.ant-tabs-tab) {
    flex: 1;
    justify-content: center;
  }
}
